export default __webpack_public_path__ + "static/media/hexagon-inner-6.af8c203f.svg";